import React from 'react'
import { motion } from 'framer-motion'
import { FacebookRounded, GitHub, Instagram, KeyboardArrowRightRounded, LinkedIn, LinkRounded, X } from '@mui/icons-material'
import ImageBuffer from '../ImageBuffer/ImageBuffer'
import { gradientArc, img1 } from '../../assets'

import './hero.css'

const Hero = () => {
  return (
    <>
        <div id='home' className='hero-wrapper'>
            <div className='hero-container'>
                <motion.div className='hero-container-main' whileInView={{ x: [-100, 0], opacity: [0, 1] }} transition={{ duration: 1 }}>
                    <h5 className="hero-text-main">
                            Software Engineer
                        <div className="hero-main-intro-img" >
                            <ImageBuffer src={gradientArc} alt="" />
                        </div>
                    </h5>

                    <div className="hero-text-sub-main"> <div className='hero-intro'>Hello, i am <span className='hero-intro-name'>Oluwasanmi,</span></div>I build practical digital solutions that solve real problems, create meaningful user experiences, and deliver reliable, professional results.</div>
                    <div className="hero-text-btr-cover">
                        <a href='#skills' className="hero-text-btr-1">
                            <span className="text-btr-main">Get Started</span>
                            <span className="text-btr-sub">Get Started</span>
                        </a>
                        <a href='#contact' className="hero-text-btr-2">
                            <span>Contact Me</span>
                            <KeyboardArrowRightRounded />
                        </a>
                    </div>

                    <ul className="hero__socials">
                        <li><a className='hero__socials_link' href={`https://facebook.com/sanmexm`} target='_blank' rel="noreferrer"><span><FacebookRounded /></span></a></li>
                        <li><a className='hero__socials_link' href={`https://instagram.com/sanmexm`} target='_blank' rel="noreferrer"><span><Instagram /></span></a></li>
                        <li><a className='hero__socials_link' href={`https://x.com/sanmexm`} target='_blank' rel="noreferrer"><span><X /></span></a></li>
                        <li><a className='hero__socials_link' href={`https://www.linkedin.com/in/manuwa-oluwasanmi-327a0898/`} target='_blank' rel="noreferrer"><span><LinkedIn /></span></a></li>
                        <li><a className='hero__socials_link' href={`https://github.com/sanmexm`} target='_blank' rel="noreferrer"><span><GitHub /></span></a></li>
                    </ul>
                </motion.div>

                <div className='hero-image-wrapper'>
                    <div className='hero-image'>
                        <ImageBuffer src={img1} alt='hero-img' />
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default Hero